import React from 'react';

class SocialIcons extends React.Component { 
    constructor(props){
        super(props);
        this.state = {
            facebookUrl : "https://www.facebook.com/sharer/sharer.php?u=",
            twitterUrl : "https://twitter.com/intent/tweet?text="+this.props.dealerName+"&url=",
            // googleUrl : "https://plus.google.com/share?url="
        }
        this.handleOpenWin = this.handleOpenWin.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this);
    } 

    handleOpenWin(event){
        event.preventDefault();
        let href = event.target;
        let link = href.getAttribute('rel');
       window.open(link, 'mywin', 'left=355,top=200,width=600,height=368,toolbar=1,resizable=0'); return false;
    }

    handleOpenModal(event){
        if((!!navigator.platform) && (/iPad|iPhone|iPod/.test(navigator.platform))) document.body.classList.add("ios-device");
    }

    render(){
        let iconStyles = null;
        let iconLinkColor = null;
        let fbStyle = null;
        let twitterStyle = null;
        // let googleStyle = null;
        let emailStyle = null;
        let icons = null;
        let id = null;

        if(this.props.template === "CROSSBAR"){
            id="id23";
        }else if(this.props.template === "CROSSBAR_LEFT"){
            id="id25";
        }

        if(this.props.template === "CROSSBAR" || this.props.template === "CROSSBAR_LEFT"){
            iconStyles = {
                marginTop : "1rem",
                fontSize : "22px",
                position : "relative" 
            }

            if(this.props.template === "CROSSBAR_LEFT_FOOTER"){
                iconStyles.float =  "right";
            }

            iconLinkColor = {
                color : "#FFF"
            }

            fbStyle = {
                backgroundColor : "rgb(66, 139, 202)",
                border : "1px solid rgb(66, 139, 202)",
                fontSize : "inherit"
            }

            twitterStyle = {
                backgroundColor : "rgb(57, 179, 215)",
                border : "1px solid rgb(57, 179, 215)",
                fontSize : "inherit"
            }
            // googleStyle = {
            //     backgroundColor : "rgb(237, 156, 40)",
            //     border : "1px solid rgb(237, 156, 40)",
            //     fontSize : "inherit"
            // }
            emailStyle = {
                backgroundColor : "rgb(71, 164, 71)",
                border : "1px solid rgb(71, 164, 71)",
                fontSize : "inherit"
            }

            icons = <div id={id} style={iconStyles} className="btn-group" role="group" aria-label="social icons" >
            <button type="button" style={fbStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.facebookUrl+this.props.shareurl}>
                <a style={iconLinkColor} href={this.state.facebookUrl+this.props.shareurl} > <i rel={this.state.facebookUrl+this.props.shareurl} className="fa fa-facebook"></i></a>
            </button>
            <button type="button" style={twitterStyle} className="btn btn-primary temp-17"  onClick={this.handleOpenWin} rel={this.state.twitterUrl+this.props.shareurl}>
                <a style={iconLinkColor} href={this.state.twitterUrl+this.props.shareurl}> <i rel={this.state.twitterUrl+this.props.shareurl} className="fa fa-twitter"></i></a>
            </button>
            {/*<button type="button" style={googleStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
                {/*<a style={iconLinkColor} href={this.state.googleUrl+this.props.shareurl}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
            {/*</button>*/}
            <button 
            type="button" 
            style={emailStyle} 
            className="btn btn-primary temp-17" 
            onClick = {this.handleOpenModal}
            data-toggle="modal" 
            data-target="#carModal">
                <a style={iconLinkColor} href="#0"> <i className="fa fa-envelope"></i></a>
            </button>
        </div>
         }else if(this.props.template === "CROSSBAR_FOOTER" || this.props.template === "CROSSBAR_LEFT_FOOTER"){
            const iconLinkColorFb = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#3b5998",
                fontSize:'18px',
                padding:'5px'
            }
    
            const iconLinkColorTwitter = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#00aced",
                fontSize: '18px',
                padding: '5px'
            }
    
            const iconLinkColorGplus = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#dd4b39",
                fontSize: '18px',
                padding: '5px'
            }
    
            const iconLinkColorEmail = {
                color: (typeof this.props.checkTheme !== 'undefined') ? "#FFFFF7" : "#000",
                fontSize: '18px',
                padding: '5px'
            }

            icons = <div style={iconStyles} className="float-left" role="group" aria-label="social icons">
                <a style={iconLinkColorFb} href={this.state.facebookUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.facebookUrl+this.props.shareurl} className="fa fa-facebook"></i></a>
                <a style={iconLinkColorTwitter} href={this.state.twitterUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl+this.props.shareurl} className="fa fa-twitter"></i></a>
                {/*<a style={iconLinkColorGplus} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
                <a style={iconLinkColorEmail} 
                href="#0" 
                onClick = {this.handleOpenModal}
                data-toggle="modal" 
                data-target="#carModal"> <i rel={this.props.shareurl} className="fa fa-envelope-o"></i></a>
        </div>

         }else if(this.props.template === "GET_STARTED" || 
         this.props.template === "GET_STARTED_FOOTER" || 
         this.props.template === "LINKED_UP" ||  
         this.props.template === "LINKED_UP_FOOTER" || 
         this.props.template === "SIMPLE_FLICKS" || 
         this.props.template === "LINKED_UP_LEFT" || 
            this.props.template === "LINKED_UP_LEFT_FOOTER" ||
            this.props.template === "LP_LINKS_WITH_ICONS") {
            iconStyles = {
                marginTop : "0",
                fontSize : "20px",
                float : "right"    
            }

            iconLinkColor = {
                color : "#C4C6C9"
            }

            if(this.props.template === "LINKED_UP" || 
            this.props.template === "LINKED_UP_LEFT" || 
            this.props.template === "LINKED_UP_FOOTER" || 
                this.props.template === "LINKED_UP_LEFT_FOOTER" ||
                this.props.template === "LP_LINKS_WITH_ICONS"
        ){
                iconLinkColor = {
                    color : "#FFF"
                }
            }

            fbStyle = {
                backgroundColor : "transparent",
                border : "1px solid transparent",
                fontSize : "inherit"
            }

            twitterStyle = {
                backgroundColor : "transparent",
                border : "1px solid transparent",
                fontSize : "inherit"
            }

            // googleStyle = {
            //     backgroundColor : "transparent",
            //     border : "1px solid transparent",
            //     fontSize : "inherit"
            // }
            emailStyle = {
                backgroundColor : "transparent",
                border : "1px solid transparent",
                fontSize : "inherit"
            }
            if (this.props.template === "LP_LINKS_WITH_ICONS") {
                let iconLinks = null;
                if(this.props.iconLinks != ""){
                    iconLinks = this.props.iconLinks.map((image) => {
                        if (image.custom_button) {
                            return  <a className="btn temp-17" href={image.link} target="_blank"><img style={{maxHeight:"30px"}} src={image.icon_url} /></a>
                        }
                    });
                }
                icons = <div id={id} style={iconStyles} className="btn-group" role="group" aria-label="social icons">{iconLinks}</div>
            } else {
            icons = <div id={id} style={iconStyles} className="btn-group" role="group" aria-label="social icons">
            <button type="button" style={fbStyle} className="btn btn-primary temp-17" onClick={this.handleOpenWin} rel={this.state.facebookUrl+this.props.shareurl}>
                <a style={iconLinkColor}  onClick={this.handleOpenWin} href={this.state.facebookUrl+this.props.shareurl}> <i rel={this.state.facebookUrl+this.props.shareurl} className="fa fa-facebook"></i></a>
            </button>
            <button type="button" style={twitterStyle} className="btn btn-primary temp-17"  onClick={this.handleOpenWin} rel={this.state.twitterUrl+this.props.shareurl}>
                <a style={iconLinkColor} href={this.state.twitterUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl+this.props.shareurl} className="fa fa-twitter"></i></a>
            </button>
            {/*<button type="button" style={googleStyle} className="btn btn-primary temp-17"  onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
                {/*<a style={iconLinkColor} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
            {/*</button>*/}
            <button type="button" 
            style={emailStyle} 
            className="btn btn-primary temp-17"   
            onClick = {this.handleOpenModal}
            data-toggle="modal" 
            data-target="#carModal"  rel={this.props.shareurl}>
                <a style={iconLinkColor} href="#0"> <i className="fa fa-envelope"></i></a>
            </button>
        </div>
            }

    } else if(this.props.template === "SOCIALIZE" || this.props.template === "SOCIALIZE_FOOTER"){
        iconStyles = {
            marginTop : "0",
            fontSize : "20px",
            float : "right"    
        }

        icons =<div className="col-md-12"><div id={id} style={iconStyles} className="btn-group" role="group" aria-label="social icons">
        <span style={fbStyle} onClick={this.handleOpenWin} rel={this.state.facebookUrl+this.props.shareurl}>
            <a   onClick={this.handleOpenWin} href={this.state.facebookUrl+this.props.shareurl}> <i rel={this.state.facebookUrl+this.props.shareurl} className="icon-facebook"></i></a>
        </span>
        <span style={twitterStyle}  onClick={this.handleOpenWin} rel={this.state.twitterUrl+this.props.shareurl}>
            <a  href={this.state.twitterUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl+this.props.shareurl} className="icon-twitter"></i></a>
        </span>
        {/*<span style={googleStyle}  onClick={this.handleOpenWin} rel={this.state.googleUrl+this.props.shareurl}>*/}
            {/*<a  href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="icon-google"></i></a>*/}
        {/*</span>*/}
        <span style={emailStyle}   
        onClick = {this.handleOpenModal}
        data-toggle="modal" 
        data-target="#carModal"  
        rel={this.props.shareurl}>
            <a  href="#0"> <i className="icon-envelope"></i></a>
        </span>
    </div>
    </div>
    }else if (this.props.template === "THEATER" 
        || this.props.template === "THEATER_CONTACT" 
        || this.props.template === "THEATER_CONTACT_FOOTER" 
        || this.props.template === "THEATER_FOOTER"
        || this.props.template === "NEWSLETTER"
        || this.props.template === "NEWSLETTER_FOOTER"
        || this.props.template === "TABBED_THEATER"
        || this.props.template === "TABBED_THEATER_FOOTER"
        || this.props.template === "THEATER_360_FOOTER") {
        const iconLinkColorFb = {
            color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#3b5998",
            fontSize:'18px',
            padding:'5px'
        }

        const iconLinkColorTwitter = {
            color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#00aced",
            fontSize: '18px',
            padding: '5px'
        }

        const iconLinkColorGplus = {
            color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#dd4b39",
            fontSize: '18px',
            padding: '5px'
        }

        const iconLinkColorEmail = {
            color: (typeof this.props.checkTheme.backgroundImage !== 'undefined') ? "#FFFFF7" : "#000",
            fontSize: '18px',
            padding: '5px'
        }

        icons = <div style={iconStyles} className="float-left" role="group" aria-label="social icons">
            <a style={iconLinkColorFb} href={this.state.facebookUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.facebookUrl+this.props.shareurl} className="fa fa-facebook"></i></a>
            <a style={iconLinkColorTwitter} href={this.state.twitterUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.twitterUrl+this.props.shareurl} className="fa fa-twitter"></i></a>
            {/*<a style={iconLinkColorGplus} href={this.state.googleUrl+this.props.shareurl} onClick={this.handleOpenWin}> <i rel={this.state.googleUrl+this.props.shareurl} className="fa fa-google"></i></a>*/}
            <a style={iconLinkColorEmail} 
            href="#0" 
            onClick = {this.handleOpenModal}
            data-toggle="modal" 
            data-target="#carModal"> <i rel={this.props.shareurl} className="fa fa-envelope-o"></i></a>
    </div>
    }
    return icons;
}
}
export default SocialIcons;


// WEBPACK FOOTER //
// ./src/components/SocialIcons.js